if ( typeof LocalizationForm !== 'function' ) {
	class LocalizationForm extends HTMLElement {

		constructor(){

			super();

			this.selector = this.querySelector('[data-js-localization-form-button]');
			this.content = this.querySelector('[data-js-localization-form-content]');
			this._prefix = window.KT_PREFIX || '';
			this.onDocumentClick = this.onDocumentClick.bind(this);
			this.onKeydown = this.onKeydown.bind(this);

			if ( ! this.selector || ! this.content ) {
				return;
			}

			this.content.setAttribute('aria-hidden', 'true');

			this.selector.addEventListener('click', e=>{
				e.stopPropagation();
				e.preventDefault();

				if ( this.querySelector('[data-js-localization-form-insert-helper-content]') && ! this.classList.contains('populated') ) {
					this.classList.add('populate');
					this.#populate();
				}

				if ( this.#isOpen() ) {
					this.close();
				} else {
					this.open({ focusFirst: e.detail === 0 });
				}
			});

			this.addEventListener('keydown', this.onKeydown);
		}

		#isOpen() {
			return this.content?.classList.contains(`${this._prefix}content-opened`);
		}

		open({ focusFirst = false } = {}) {
			if ( ! this.selector || ! this.content ) {
				return;
			}

			document.querySelectorAll('localization-form').forEach(form => {
				if ( form !== this && typeof form.close === 'function' ) {
					form.close();
				}
			});

			this.content.classList.add(`${this._prefix}content-opened`);
			this.content.setAttribute('aria-hidden', 'false');
			this.selector.setAttribute('aria-expanded', 'true');
			this.content.parentNode.style.zIndex = 1000;

			if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
				this.content.classList.add(`${this._prefix}invert-y`);
			}
			if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
				this.content.classList.add(`${this._prefix}invert-x`);
			}

			requestAnimationFrame(() => this.#revealSelectedOption());

			document.addEventListener('click', this.onDocumentClick);

			if ( focusFirst ) {
				requestAnimationFrame(() => this.content.querySelector('button, a, [tabindex="0"]')?.focus());
			}
		}

		close({ restoreFocus = false } = {}) {
			if ( ! this.selector || ! this.content ) {
				return;
			}

			this.content.classList.remove(
				`${this._prefix}content-opened`,
				`${this._prefix}opened-with-tab`,
				`${this._prefix}invert-x`,
				`${this._prefix}invert-y`
			);
			this.content.setAttribute('aria-hidden', 'true');
			this.selector.setAttribute('aria-expanded', 'false');
			this.content.parentNode.style.zIndex = 9;
			document.removeEventListener('click', this.onDocumentClick);

			if ( restoreFocus ) {
				this.selector.focus();
			}
		}

		onDocumentClick(event) {
			if ( ! this.contains(event.target) ) {
				this.close();
			}
		}

		onKeydown(event) {
			if ( event.key === 'Escape' && this.#isOpen() ) {
				event.preventDefault();
				this.close({ restoreFocus: true });
				return;
			}

			if ( event.currentTarget === this && event.target === this.selector && event.key === 'ArrowDown' ) {
				event.preventDefault();
				this.open({ focusFirst: true });
			}
		}

		disconnectedCallback() {
			document.removeEventListener('click', this.onDocumentClick);
			this.removeEventListener('keydown', this.onKeydown);
		}

		#revealSelectedOption() {
			const selected = this.content?.querySelector('.localization-form__content-item--selected');
			if ( ! selected ) {
				if ( this.content ) this.content.scrollTop = 0;
				return;
			}

			const maxScroll = Math.max(0, this.content.scrollHeight - this.content.clientHeight);
			const centered = selected.offsetTop - ((this.content.clientHeight - selected.offsetHeight) / 2);
			this.content.scrollTop = Math.min(maxScroll, Math.max(0, centered));
		}

		#populate() {
			fetch('?section_id=helper-localization-form').then(response=>response.text())
				.then(text => {
					const helper = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-helper-localization-form');
					if ( ! helper ) {
						throw new Error('Localization helper section was not found');
					}
					this.querySelector('[data-js-localization-form-insert-helper-content]').innerHTML = helper.innerHTML;
					this.classList.remove('populate');
					this.classList.add('populated');
					if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
						this.content.classList.add(`${this._prefix}invert-y`);
					}
					if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
						this.content.classList.add(`${this._prefix}invert-x`);
					}
				})
				.catch(error=>{
					this.classList.remove('populate');
					console.warn('Localization options could not be loaded.', error);
				});
		}

	}

	if ( typeof customElements.get('localization-form') == 'undefined' ) {
		customElements.define('localization-form', LocalizationForm);
	}

}
